import {useEffect, useState} from "react";
import styled from 'styled-components';

import {useParams} from "react-router-dom";
import useFeedback from "../../../utils/use_feedback";
import {useCommunitySettings, useSaveSettings} from "../../../api/communities";
import {useSaveClicked} from "../../../store";
import FormContainer from "../../../components/form_container";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import {FormControl, Select, Stack, Switch, useToast} from "@chakra-ui/react";

const SwitchHeading = styled.div``;

const PrivacyCommunitySettings = styled(({className}) => {
    const {community} = useParams();
    const {error, feedbackCh} = useFeedback();
    const [settings, setSettings] = useState({
            displayName: '',
            appSafe: '',
            description: '',
            topics: [],
            nsfw: false,
        }
    );
    useCommunitySettings(feedbackCh, community, setSettings);
    const set = (name) => (value) => setSettings((settings) => ({...settings, [name]: value}));

    const saveSettings = useSaveSettings(feedbackCh);
    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    const toast = useToast();
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    toast({
                        title: `Saving...`,
                        status: 'info',
                        isClosable: true,
                    });
                    await saveSettings(community, settings);
                    toast.closeAll();
                    toast({
                        title: `Saved settings.`,
                        status: 'success',
                        isClosable: true,
                    });
                    setSaving(false);
                }
            }
        })().then(() => {
        }, () => {
        });
    }, [saveClicked]);

    return (
        <>
            <FixedTopBar back title="Privacy and Safety" border={false} save/>
            <WhiteMain className={className}>
                <FormContainer>
                    <Stack spacing={'1'} mb={6}>
                        <SwitchHeading style={{padding: '6px 0'}}>Community Visibility</SwitchHeading>
                        <Select value={settings.visibility}
                                onChange={(e) => set('visibility')(e.currentTarget.value)}>
                            <option value="public">Public</option>
                            <option value="restricted">Restricted</option>
                            <option value="unlisted">Unlisted</option>
                        </Select>
                    </Stack>
                    <FormControl display='flex' mb={6}>
                        <SwitchHeading mb='0'>
                            Community is safe for App Stores
                        </SwitchHeading>
                        <Switch isChecked={settings.appSafe} onChange={(ev) => set('appSafe')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                    <FormControl display='flex' mb={6}>
                        <SwitchHeading mb='0'>
                            Notify Users on Report Conclusion
                        </SwitchHeading>
                        <Switch isChecked={settings.notifyReportConclusion} onChange={(ev) => set('notifyReportConclusion')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                    <FormControl display='flex' mb={6}>
                        <SwitchHeading mb='0'>
                            Public Moderation Logs
                        </SwitchHeading>
                        <Switch isChecked={settings.publicLogs} onChange={(ev) => set('publicLogs')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                    <FormControl display='flex' mb={6}>
                        <SwitchHeading mb='0'>
                            Hide Moderators in Logs
                        </SwitchHeading>
                        <Switch isChecked={settings.obsfucatedLogs} onChange={(ev) => set('obsfucatedLogs')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                    <FormControl display='flex'>
                        <SwitchHeading mb='0'>
                            Public Ban Logs
                        </SwitchHeading>
                        <Switch isChecked={settings.banLogs} onChange={(ev) => set('banLogs')(ev.target.checked)} ml={'auto'}/>
                    </FormControl>
                </FormContainer>

            </WhiteMain>
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
  ${SwitchHeading} {
    font-weight: 600;
    font-size: 15px;
    padding: 2px 0;
  }
`;

export default PrivacyCommunitySettings;
